import { Component } from 'react';
import { AuthContext, postData } from './constants.js';
import { Navigate } from "react-router-dom";

class Login extends Component {
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      useremail : "",
      password  : "",
      isOTPgenerated : false,
      disableForm    : false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value =  target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    var loginNote = document.getElementById("login-note");
    loginNote.innerHTML = "";
    this.setState({disableForm:true});
    let { signIn }  = this.context;
    if(this.state.isOTPgenerated){
      signIn({ useremail: this.state.useremail, password: this.state.password });
    }else{
      var data = {useremail:this.state.useremail};
      postData('/generateOTP', data)
        .then((response) => {
          if(response.error){
            loginNote.innerHTML = response.message;
            this.setState({isOTPgenerated:false, disableForm:false});
          }else{
            this.setState({isOTPgenerated:true, disableForm:false});
          }
        }).catch((e) => {
          loginNote.innerHTML = e.message;
          this.setState({isOTPgenerated:false, disableForm:true});
        });
    }
  }

  render(){
    const isLoggedIn = sessionStorage.getItem("userToken");
    if(isLoggedIn){
      return(
        <Navigate to="/" />
      );
    }else{
      return(
        <>
        <div className="container mt-5 pt-5">
            <div className="row justify-content-center">
                <div className="col-xl-10 col-lg-12 col-md-9">
                    <div className="card o-hidden border-0 shadow-lg">
                        <div className="card-body p-3">
                            <div className="row ml-5">
                                <div className="col-lg-6 d-none d-lg-block align-items-center justify-content-center">
                                    <img src="./img/logo.png" className="img-fluid" />
                                </div>
                                <div className="col-lg-6">
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h2 className="font-weight-bold text-success">Property Owner Login</h2>
                                            <h1 className="h4 text-gray-900 mb-4">Welcome to Whispering Oaks Estates</h1>
                                        </div>
                                        <form id="formLogin" onSubmit={this.handleSubmit} className="user" autoComplete="off">
                                          <fieldset id="LoginField" disabled={this.state.disableForm}>
                                            <div className="form-group pt-3">
                                              {this.state.isOTPgenerated?(
                                                <>
                                                <h6 className="text-primary fw-bold px-2"> OTP has been sent to your email. </h6>
                                                <label className="px-2"> Enter your OTP here </label>
                                                <input type="password" name="password" className="form-control form-control-user"
                                                  id="floatingPassword" placeholder="One Time Password" maxLength="6"
                                                  value={this.state.password} onChange={this.handleInputChange} required
                                                />
                                                </>
                                              ):(
                                                <>
                                                <label className="px-2 text-dark"> Enter your email address </label>
                                                <input type="text" className="form-control form-control-user"
                                                  id="floatingInput" name="useremail" aria-describedby="emailHelp"
                                                  placeholder="abc@gmail.com"
                                                  value={this.state.useremail} onChange={this.handleInputChange} required
                                                />
                                                </>
                                              )}
                                              <small id="login-note" className="text-danger mb-4"> </small>
                                            </div>
                                            {
                                            /*
                                            <div className="form-group">
                                                <div className="custom-control custom-checkbox small">
                                                    <input type="checkbox" className="custom-control-input" id="customCheck" />
                                                    <label className="custom-control-label">Remember Me</label>
                                                </div>
                                            </div>
                                            */
                                            }
                                            <button type="submit" className="btn btn-primary btn-user btn-block"> {this.state.isOTPgenerated?'Submit':'Next'} </button>
                                            <hr />
                                          </fieldset>
                                        </form>
{/*                                        <hr />
                                        <div className="text-center">
                                            <a className="small" href="/forgot-password">Forgot Password?</a>
                                        </div>
                                        <div className="text-center">
                                            <a className="small font-weight-bold" href="/register">Create an Account!</a>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
      );
    }
  }
}

export { Login };
